angular.module('autoremind.dev', [])
    .controller('autoremind.dev.test.ScreenController', 
// Setup dependencies
['$scope', '$http', '$log', 'logger', 'userProfile', '$enhancedHttp',
    function ($scope, $http, $log, logger, userProfile, $enhancedHttp) {
        $scope.viewModel = {};
        $scope.updateTick = 0;
        $log.info('In autoremind.reports.ScreenController');
        userProfile.initalizeViewModel();
        if (!angular.isDefined(userProfile.viewModel.views.dev)) {
            userProfile.viewModel.views.dev = {};
        }
        if (!angular.isDefined(userProfile.viewModel.views.dev.test)) {
            userProfile.viewModel.views.dev.test = {};
        }
        // Map shared model to scope for local reference
        $scope.viewModel = userProfile.viewModel.views.dev.test;
        $scope.viewModel.url = '/servlets/messages/123/?offset=0';
        $scope.viewModel.methods = ['POST', 'GET', 'PUT', 'DELETE'];
        $scope.viewModel.method = 'POST';
        $scope.viewModel.json = '{}';
        $scope.callServlet = function (url) {
            console.log('url: ' + $scope.viewModel.url);
            $enhancedHttp({
                method: $scope.viewModel.method,
                headers: { 'Content-Type': 'application/json' },
                url: $scope.viewModel.url,
                data: $scope.viewModel.json
            })
                .then(function (data, status) {
                $scope.viewModel.status = status;
                $scope.viewModel.data = data;
            }, function (data, status) {
                $scope.viewModel.data = data;
                $scope.viewModel.status = status;
                //            $scope.viewModel.error = data;
                logger.error('Error getting messages data from server');
            });
        };
    }]);
//# sourceMappingURL=test.controllers.js.map